import type { PropsWithChildren } from 'react';
import React from 'react';

import { Text } from '@change/ds-core-ui/next';

export const CalloutBody: React.FC<CalloutBodyProps> = ({ children }) => {
	return <Text variant="body">{children}</Text>;
};

type CalloutBodyProps = PropsWithChildren;
